import * as yup from 'yup';

import { emailYupValidation } from './validationSchema';

export const tecnicoOrdenTrabajoFormSchema = yup.object().shape({
  coordenadas: yup.string().required('Las coordenadas son requeridas'),
  coordenadas_2: yup.string().optional(), // lat/lng
  email: emailYupValidation,
  telefono_fijo: yup.string().required('El campo telefono fijo es requerido'),
  celular: yup.string().required('El campo celular es requerido'),
  persona_referencia: yup
    .string()
    .required('La persona de referencia es requerida'),
  celular_referencia: yup
    .string()
    .required('El campo celular de referencia es requerido'),
  parentesco_referencia: yup
    .string()
    .required('El campo parentesco de referencia es requerido'),
  direccion: yup.string().required('El campo direccion es requerido'),

  tipo_instalacion: yup
    .string()
    .required('El campo tipo de instalacion es requerido'),

  nap: yup.string().required('El campo nap es requerido'),
  distancia: yup.string().required('El campo distancia es requerido'),

  ip_publica: yup.string().required('El campo IP pública es requerido'),
  olt: yup.string().required('El campo olt es requerido'),
  splitter: yup.string().required('El campo splitter es requerido'),
  manga: yup.string().required('El campo manga es requerido'),
  color_hilo: yup.string().required('El campo color de hilo es requerido'),
  num_hilo: yup.string().required('El campo número de hilo es requerido'),
  potencia_dbm: yup.string().required('El campo potencia dbm es requerido'),

  conexion_tierra: yup.string().optional(),
  regulador: yup.string().optional(),

  potencia_ont: yup.string().required('El campo potencia ont es requerido'),
  test_5g: yup.string().required('El campo test 5g es requerido'),
  // pon_serial_ont: yup.string().required('El campo pon serial ont es requerido'),
  ubicacion_ont: yup.string().required('El campo ubicación ont es requerido'),
  ubicacion_equipo_ac: yup
    .string()
    .required('El campo ubicación del equipo AC es requerido'),
  // serial_mac_ac: yup.string().required('El campo serial MAC AC es requerido'),

  // TODO: make required
  otros_materiales: yup.string().optional(),
  // .required('El campo otros materiales es requerido'),
  materiales_contrato: yup.string().optional(),
  // .required('El campo materiales de contrato es requerido'),
  materiales_adicionales: yup.string().optional(),
  // .required('El campo materiales adicionales es requerido'),
  equipos_asignados: yup.string().optional(),
  // .required('El campo equipos asignados es requerido'),
  equipos_nuevos: yup.string().optional(),
  // .required('El campo equipos nuevos es requerido'),

  // ------ Fotos ------
  orden_trabajo_foto: yup.string().optional(),
  foto_nap: yup.string().optional(),
  foto_test_5g: yup.string().optional(),
  foto_pon_serial_ont: yup.string().optional(),
  foto_ubicacion_ont: yup.string().optional(),
  foto_croquis_virtual: yup.string().optional(),
  foto_potencia_ont: yup.string().optional(),
  foto_materiales_contrato: yup.string().optional(),
  foto_ubicacion_equipo_ac: yup.string().optional(),
  foto_serial_mac_ac: yup.string().optional(),
  foto_cliente_contrato: yup.string().optional(),

  croquis_virtual: yup.string().optional(),
  bloquear_hasta: yup.string().optional().nullable(),

  observacion: yup.string().optional(),
  observacion_2: yup.string().optional(),
  observacion_4: yup.string().optional(),
  tipo_incidencia: yup.string().optional().nullable(),
  prioridad_incidencia: yup.string().optional().nullable(),

  user: yup
    .number()
    .typeError(value => {
      const key = Object.keys(value)[0];
      return `El campo ${key} debe ser un número`;
    })
    .required('El campo user es requerido'),

  ciudad: yup.string().required('El campo ciudad es requerido'),
  // zona: yup
  //   .number()
  //   .typeError('El campo zona debe ser un número')
  //   .required('El campo zona es requerido'),
  // sector: yup
  //   .number()
  //   .typeError('El campo sector debe ser un número')
  //   .required('El campo sector es requerido'),

  estado: yup.string().required('El campo estado es requerido'),

  // motivo: yup.string().when('estado', {
  //   is: EstadoOrdenTrabajoCodigoEnum.PRE_RECHAZADA.toString(),
  //   then: schema => schema.required('Para el recharzo es necesario un motivo'),
  // }),

  ///* helpers
  // latitud2: yup
  //   .string()
  //   .required('La latitud del croquis virtual es requerida'),
  // longitud2: yup
  //   .string()
  //   .required('La longitud del croquis virtual es requerida'),

  ///* activacion
  direccion_ip: yup.string().required('La direccion IP es requerido'),
  puerto: yup
    .number()
    .typeError('El puerto es requerido')
    .required('El puerto es requerido'),
  router_ac: yup.string().required('El router AC es requerido'),
  observacion_3: yup.string().optional(),
  pppoe: yup.string().required('El campo pppoe es requerido'),
  pppassword: yup.string().required('El campo pppassword es requerido'),

  ///* pyl - Ahora Activacion es quien setea la hora inicio/fin
  hora_inicio: yup.string().required('La hora de inicio es requerida'),
  // hora_fin: yup.string().required('La hora de fin es requerida'),

  // tecnico
  cable_inicio: yup
    .number()
    .typeError('El cable inicio es requerido')
    .required('El cable inicio es requerido'),
  cable_fin: yup
    .number()
    .typeError('El cable fin es requerido')
    .required('El cable fin es requerido')
    .test(
      'cable_fin',
      'El cable fin debe ser mayor al cable inicio',
      function (value) {
        return +value > +this.parent.cable_inicio;
      }
    ),
  codigo_bobina: yup.string().required('El codigo de bobina es requerido'),
  utp_utilizado: yup
    .number()
    .typeError('La cantidad de UTP utilizada es requerida')
    .required('La cantidad de UTP utilizada es requerida'),
});

export const tecnicoRejectOrdenTrabajoFormSchema = yup.object({
  motivo: yup
    .string()
    .required('El campo motivo es requerido')
    .max(255, 'El campo motivo no debe exceder los 255 caracteres'),
  estado: yup
    .number()
    .typeError('El estado es requerido')
    .required('El estado es requerido'),
  observacion_rechazo_tecnico: yup
    .string()
    .required('El campo observación de rechazo es requerido'),
  foto_rechazo_tecnico_1: yup.string().optional(),
  foto_rechazo_tecnico_2: yup.string().optional(),
});

export const activacionAproveRejectFormSchema = yup.object({
  motivo: yup
    .string()
    .optional()
    .max(255, 'El campo motivo no debe exceder los 255 caracteres'),
  estado: yup
    .number()
    .typeError('El estado es requerido')
    .required('El estado es requerido'),
  fecha_hora_activacion: yup
    .string()
    .required('La fecha y hora de activación es requerida'),
  estado_activacion: yup
    .string()
    .required('El estado de activación es requerido'),
});

///* OT
export const tecnicoOTActivacionFormSchema = yup.object({
  direccion_ip: yup.string().required('La direccion IP es requerido'),
  puerto: yup.number().required('El puerto es requerido'),
  router_ac: yup.string().required('El router AC es requerido'),
  observacion_3: yup.string().optional(),
});

export const comprobanteFormSchema = yup.object({
  numero_comprobante: yup.string().required('Campo requerido'),
});

export const activacionRejectFormSchema = yup.object({
  motivo_rechazo_auditoria: yup.string().required('El motivo es requerido'),
  usuario_rechazo_auditoria: yup
    .number()
    .typeError('El usuario es requerido')
    .required('El usuario es requerido'),
  fecha_hora_rechazo_auditoria: yup
    .string()
    .required('La fecha y hora de rechazo es requerida'),
  estado: yup.string().required('El estado es requerido'),
  user: yup
    .number()
    .typeError('El usuario es requerido')
    .required('El usuario es requerido'),
});
